import { useState, useEffect } from 'react';
import ZTabs from '@/components/shared/ZTabs';
import GolfTab from '@/components/verve/GolfTab';
import Logotype from '@/components/shared/Logotype';

const VERVE_RED = '#FF0042';
const MONO = "'JetBrains Mono', monospace";

// Golf only for now. Padel and Gym slot in here once Apple Health data flows;
// the tab bar shows itself again as soon as there is more than one tab.
const TABS = [{ id: 'Golf', label: 'Golf' }];

// ── VERVE main page ───────────────────────────────────────────────────────────
export default function Verve() {
  const [tab, setTab] = useState('Golf');

  useEffect(() => {
    document.title = 'Verve';
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0f', color: '#f0f0f5', display: 'flex', flexDirection: 'column' }}>
      {/* App header */}
      <div className="app-header" style={{ padding: '28px 24px 16px', borderBottom: '0.5px solid rgba(255,255,255,0.06)', flexShrink: 0 }}>
        <div className="flex items-center mb-1">
          <Logotype app="verve" size="header" />
        </div>
        <div style={{ fontFamily: MONO, fontSize: 12, letterSpacing: '0.2em', color: '#b0b4c0', marginTop: 4, textTransform: 'uppercase', paddingLeft: 2 }}>
          Forging Freedom
        </div>
      </div>

      {TABS.length > 1 && <ZTabs tabs={TABS} activeTab={tab} onChange={setTab} accent={VERVE_RED} />}

      {/* Tab content */}
      <div style={{ flex: 1, overflowY: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {tab === 'Golf' && <GolfTab />}
      </div>
    </div>
  );
}
